import { SessionStorage } from 'app/storage/session.storage';
import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MeetingFormService } from 'app/form/meeting-form/meeting-form.service';
import { fieldElementId } from 'app/shared/forms/form-validation.util';

@Component({
  selector: 'open-question',
  template: `
    <div class="box__openq" [id]="fieldId" [class.box__openq--invalid]="submitted && isInvalid()">
      <label class="open-question-label">
        {{ question }}<span *ngIf="(type === 'report' || type === 'survey') && required" class="req-mark">*</span>
      </label>
      <div *ngIf="description" class="open-question-description" [innerHTML]="description"></div>
      <form [formGroup]="form">
        <textarea *ngIf="editor == 'area'"
                  [formControlName]="question"
                  class="textarea"
                  placeholder="Type your answer here…">
        </textarea>
        <div class="ck-content" *ngIf="editor === 'editor'">
          <ckeditor [config]="{ toolbar: [ 'bold', 'italic', '|', 'undo', 'redo', 'numberedList', 'bulletedList', '|', 'link' ]}"
                    [editor]="Editor" [formControlName]="question" [data]="question">
          </ckeditor>
        </div>
      </form>
    </div>
  `,
  styleUrls: ['./styles/ckeditor.scss'],
  styles: [`
    .box__openq {
      padding: 12px 14px;
      background: #fafcfe;
      border: 1px solid #e4e8ee;
      border-radius: 6px;
      margin-bottom: 12px;
    }
    .box__openq--invalid {
      border-color: var(--form-error, #e74c3c);
      background: var(--form-error-bg, #fdecea);
    }
    .open-question-label {
      display: block;
      font-size: 13px;
      font-weight: 700;
      color: #222;
      margin-bottom: 6px;
      line-height: 1.4;
    }
    .req-mark {
      color: var(--form-error, #e74c3c);
      font-weight: 700;
      margin-left: 3px;
    }
    .open-question-description {
      font-size: 12px;
      color: #666;
      margin-bottom: 10px;
      line-height: 1.5;
    }
    ::ng-deep .open-question-description a {
      color: #004E9A !important;
      text-decoration: underline !important;
      font-weight: 600 !important;
    }
    ::ng-deep .open-question-description a:hover {
      color: #003b78 !important;
    }
    .textarea {
      width: 100%;
      min-height: 140px;
      padding: 10px 12px;
      font-size: 13px;
      color: #333;
      line-height: 1.55;
      border: 1px solid #d0dce8;
      border-radius: 4px;
      background: #fff;
      resize: vertical;

      &:focus {
        outline: none;
        border-color: #004E9A;
        box-shadow: 0 0 0 2px rgba(0,78,154,.12);
      }
    }
  `]
})
export class OpenQuestionComponent implements OnInit {

  @Input()
    editor: string[] | string = ''

  @Input()
    question: string  = 'Question'

  @Input()
    type: string = ""

  @Input()
    description: string[] |string = ""

  @Input()
    required: boolean = true

  @Input()
    submitted: boolean = false

  public Editor = ClassicEditor

  get fieldId(): string {
    return fieldElementId(this.question)
  }

  isInvalid(): boolean {
    return !!this.form.get(this.question)?.invalid
  }

  meetingsOrder = [
    'first', 'second', 'third', 'fourth', "final"
  ]

  MEETING_FORM = 0

  form : FormGroup = this.fb.group({})

  constructor(
    private formService: MeetingFormService,
    private fb: FormBuilder,
    private auth: SessionStorage
  ) {
    
   }

  ngOnInit(): void {
    switch(this.type){
      case "survey":
          if(this.auth.isProject()){
            this.form = this.formService.getProjectSurveyForm()
          }
          else{
            this.form = this.formService.getEpeSurveyForm()
          }
          break
      case "report":
          this.form = this.formService.getReportForm()
          break
        case "advice_project_survey":
          this.form = this.formService.getProjectAdviceForm()
          break
        case "project_survey_meeting":
          this.form = this.formService.getProjectSurveyMeetingForm()
          break
      default:
          this.form = this.formService.getForm()
  }
  }

  


}
